package com.exura.components.layouts.plan

import com.exura.components.inputs.ModeToggleOption
import com.exura.features.planConstruction.planConstructionLocalization
import com.exura.ui.Assets

enum class ViewMode {
    TEXT, GRAPHICS;
}

val VIEW_MODES_ITEMS = listOf(
    ModeToggleOption(
        ViewMode.TEXT,
        planConstructionLocalization.current.toggles.viewModeText,
        Assets.IconsUntiled.PREVIEW_TEXT
    ),
    ModeToggleOption(
        ViewMode.GRAPHICS,
        planConstructionLocalization.current.toggles.viewModeGraphics,
        Assets.IconsUntiled.TIMELINE,
    ),
)
